import { CALL_CONFIG } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isLoading: true,
  contactCenterDetails: [],
  callFlowDetails: [],
  callConfigList: [],
  dupUpdate: [],
  queueData: [],
  editCallConfig: {},
  error: {
    hasError: false,
    errorMessage: "",
  },
};

const callConfigSlice = createSlice({
  name: CALL_CONFIG,
  initialState,
  reducers: {
    contactCenterDetails: (state, { payload }) => {
      state.contactCenterDetails = payload.length > 0 ? payload : [];
    },
    callFlowDetails: (state, { payload }) => {
      state.callFlowDetails = payload.length > 0 ? payload : [];
    },
    callConfigList: (state, { payload }) => {
      state.callConfigList = payload.length > 0 ? payload : [];
    },
    dupUpdate: (state, { payload }) => {
      state.dupUpdate = payload.length > 0 ? payload : [];
    },
    queueData: (state, { payload }) => {
      state.queueData = payload.length > 0 ? payload : [];
    },
    isLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    reset: () => { },
  },
});

export const callConfigActions = callConfigSlice.actions;
export default callConfigSlice.reducer;
